module.exports = require('./helpers/bundle-url').getBundleURL('hRXdN') + "sea-ice-thick--dataset-cover.7f548e59.jpg";